import { getFunctions, httpsCallable, HttpsCallable } from 'firebase/functions'
import { PhoneRoutingRule } from '@super-software-inc/foundation'

export type APIPhoneRoutingRule = PhoneRoutingRule & {
  id: string
}

export const getPhoneRoutingRules = async (
  companyId: string,
): Promise<APIPhoneRoutingRule[]> => {
  const functions = getFunctions()
  functions.region = 'us-east1'
  const getPhoneRoutingRulesAPI: HttpsCallable<
    { companyId: string },
    APIPhoneRoutingRule[]
  > = httpsCallable(functions, 'getPhoneRoutingRules')

  const phoneRoutingRules = await getPhoneRoutingRulesAPI({ companyId })
  return phoneRoutingRules.data
}

export const createPhoneRoutingRule = async (
  companyId: string,
  phoneRoutingRule: Partial<APIPhoneRoutingRule>,
): Promise<APIPhoneRoutingRule> => {
  const functions = getFunctions()
  functions.region = 'us-east1'
  const createPhoneRoutingRuleAPI: HttpsCallable<
    { companyId: string; phoneRoutingRule: Partial<APIPhoneRoutingRule> },
    APIPhoneRoutingRule
  > = httpsCallable(functions, 'createPhoneRoutingRule')

  const rule = await createPhoneRoutingRuleAPI({
    companyId,
    phoneRoutingRule,
  })

  return rule.data
}

export const updatePhoneRoutingRule = async (
  phoneRoutingRuleId: string,
  companyId: string,
  phoneRoutingRule: Partial<APIPhoneRoutingRule>,
): Promise<APIPhoneRoutingRule> => {
  const functions = getFunctions()
  functions.region = 'us-east1'
  const updatePhoneRoutingRuleAPI: HttpsCallable<
    {
      companyId: string
      phoneRoutingRuleId: string
      phoneRoutingRule: Partial<APIPhoneRoutingRule>
    },
    APIPhoneRoutingRule
  > = httpsCallable(functions, 'updatePhoneRoutingRule')

  const rule = await updatePhoneRoutingRuleAPI({
    companyId,
    phoneRoutingRuleId,
    phoneRoutingRule,
  })

  return rule.data
}

export const deletePhoneRoutingRule = async (
  phoneRoutingRuleId: string,
  companyId: string,
): Promise<void> => {
  const functions = getFunctions()
  functions.region = 'us-east1'
  const deletePhoneRoutingRuleAPI: HttpsCallable<
    { phoneRoutingRuleId: string; companyId: string },
    void
  > = httpsCallable(functions, 'deletePhoneRoutingRule')

  await deletePhoneRoutingRuleAPI({ phoneRoutingRuleId, companyId })
}
